'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var SearchIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<circle cx="7.5" cy="7.5" r="5.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/><path d="M15.53 15.53L11.47 11.47"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/>';
    case 'medium':
      return '<circle cx="13" cy="13" r="11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/><path d="M29.51 29.51L21 21" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/>';
    case 'large':
      return '<circle cx="20.5" cy="20.5" r="17" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/><path d="M44.5 44.5L32.5 32.5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/>';
    }
  }
});

module.exports = SearchIcon;



/** WEBPACK FOOTER **
 ** ./atoms/icons/Search.jsx
 **/